import React, {
    useContext
} from 'react';
import cn from 'classnames';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from '@ferris/react';
import { ButtonType } from '@ferris/react/components/button/Button';
import { DomUtilsCtx } from '../../../contexts/domUtils';
import LoginButton from '../../Utils/LoginButton';
import TranslationUtil from '../../../utils/TranslationUtil';
import { LODGIN_TYPES } from '../../../actions/classification';

const getPropsFromState = (state) => {
    const { app } = state;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const ctaCopy = translations.getTranslation('cta.listing_preference_a.text');
    const ctaConventionalLodging = translations.getTranslation('cta.listing_preference_a.conventional_lodging');
    const ctaVacationRental = translations.getTranslation('cta.listing_preference_a.vacation_rental');
    return {
        ctaCopy,
        ctaConventionalLodging,
        ctaVacationRental
    };
};

const CtaVersionA = () => {
    const {
        isLypFormVisible,
        handleLodgingPreferenceChange
    } = useContext(DomUtilsCtx);

    const {
        ctaCopy,
        ctaConventionalLodging,
        ctaVacationRental
    } = useSelector(getPropsFromState, shallowEqual);

    const actionLocation = 'cta_version_a';

    return (
        <>
            <div
                className={cn('cta-listing-preference-a', 'lyp-cta-container', {
                    visible: !isLypFormVisible
                })}
            >
                <p>{ctaCopy}</p>
                <div className={cn('cta-button-group')}>
                    <Button
                        data-wdio="lyp-cta-hotel"
                        htmlButtonType="button"
                        type={ButtonType.PRIMARY}
                        variant="primary"
                        id="lypCtaHotel"
                        onClick={() => {
                            handleLodgingPreferenceChange(LODGIN_TYPES.CL, actionLocation);
                        }}
                    >
                        {ctaConventionalLodging}
                    </Button>
                    <Button
                        data-wdio="lyp-cta-vacation-rental"
                        htmlButtonType="button"
                        type={ButtonType.PRIMARY}
                        variant="primary"
                        id="lypCtaVacationRental"
                        onClick={() => {
                            handleLodgingPreferenceChange(LODGIN_TYPES.VR, actionLocation);
                        }}
                    >
                        {ctaVacationRental}
                    </Button>
                </div>
            </div>
            <LoginButton
                display
                classes={cn({
                    'hide-desktop': !isLypFormVisible
                },
                'login-cta-va')}
            />
        </>
    );
};

export default CtaVersionA;
